import createApp from './app'

const { app, router } = createApp()

;(async (r, a) => {
  await r.isReady()
  a.mount('#app', true)
})(router, app)
